import { SelectPositionButton } from 'components/minute/sidebar/shared/SelectPositionButton';
import { LocationSearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/LocationSearchInput';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { useContext } from 'react';
import { ICoordinates, IIconV2WorldMarker, IVariantIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker | IVariantIconV2WorldMarker;
}

export const IconMarkerLocationSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    function updateCoordinate(coordinate: ICoordinates) {
        ctxEdit.updateWorldMarker(props.marker.id, {
            lat: coordinate.lat,
            lng: coordinate.lng
        });
    }

    return (
        <S_IconMarkerLocationSection className={props.className}>
            <SidebarSection title={Localization.LOCATION} icon={{ iconName: 'crosshairs' }}>
                <SidebarContent withHover withTopPadding>
                    <SidebarSectionRow>
                        <LocationSearchInput
                            onLocationSelected={({ lat, lng }) => {
                                updateCoordinate({ lat, lng });
                                ctxEdit?.mapRef.current?.flyTo({
                                    center: [lng, lat],
                                    zoom: 13
                                });
                            }}
                        />
                    </SidebarSectionRow>
                    <SidebarSectionRow alignment="end">
                        <SelectPositionButton
                            mapRef={ctxEdit.mapRef.current}
                            onCoordinateSelected={(coordinate) => {
                                updateCoordinate(coordinate);
                            }}
                        />
                    </SidebarSectionRow>
                </SidebarContent>
            </SidebarSection>
        </S_IconMarkerLocationSection>
    );
};

const S_IconMarkerLocationSection = styled.div``;
